var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('earth-layout',[_c('template',{slot:"A"},[_c('u-header',{attrs:{"title":_vm.$t('_.cancellation_requests')}}),_vm._v(" "),_c('contract-cancellation-requests-table',{attrs:{"id":"CCRT1"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }